const wowApp = require('angular').module('wowApp.shop');

wowApp.component('wowPrice', require('./price.component').priceControllerComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/price/index.js